export default __webpack_public_path__ + "static/media/audiophile2.a376cae6.jpg";